<template>
  <button :class="['group hover:cursor-pointer']" :aria-label="isOpen ? 'Sluit menu' : 'Open menu'">
    <div class="flex flex-col justify-between items-center w-[18px] h-[18px]">
      <div
        :class="[
          'w-full h-0.5 transition-all duration-200 ease-smooth origin-center',
          variant === 'white' ? 'bg-white' : 'bg-primary-100',
          isOpen ? 'rotate-45 translate-y-[8px]' : 'group-hover:scale-x-[0.6]',
        ]" />
      <div
        :class="[
          'w-full h-0.5 transition-all duration-200 ease-smooth',
          variant === 'white' ? 'bg-white' : 'bg-primary-100',
          isOpen ? 'opacity-0' : 'opacity-100',
        ]" />
      <div
        :class="[
          'w-full h-0.5 transition-all duration-200 ease-smooth origin-center',
          variant === 'white' ? 'bg-white' : 'bg-primary-100',
          isOpen ? '-rotate-45 -translate-y-[8px]' : 'group-hover:scale-x-[0.6]',
        ]" />
    </div>
  </button>
</template>

<script setup lang="ts">
const { variant = 'white' } = defineProps<{
  isOpen: boolean
  variant?: 'white' | 'black'
}>()
</script>

